import { useGetFolderQuery, useGetWorkspaceQuery } from '@carboncopyco/data';
import { FolderIcon, RightOutlineIcon } from '@carboncopyco/icons';
import type { DirectoryEntity } from '@carboncopyco/types';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import { WorkspaceAvatar } from '../../../Workspaces';

export type AssetLocationBreadcrumbsContentProps = {
  organizationId: string;
  workspaceId: string;
  location: { id: string; entity: DirectoryEntity };
  withWorkspaceName?: boolean;
};

export const AssetLocationBreadcrumbsContent = ({
  location,
  withWorkspaceName,
  workspaceId,
  organizationId,
}: AssetLocationBreadcrumbsContentProps) => {
  const { data: folder } = useGetFolderQuery(
    {
      organizationId,
      workspaceId,
      folderId: location.id,
    },
    { skip: location.entity !== 'folder' }
  );

  const { data: workspace } = useGetWorkspaceQuery(
    {
      organizationId,
      id: location.entity === 'workspace' ? location.id : folder?.workspaceId,
    },
    { skip: location.entity === 'folder' && !folder }
  );
  return (
    <div className="flex items-center gap-1">
      {workspace && (
        <div className="basis-1 flex items-center gap-1">
          <WorkspaceAvatar
            size="xsmall"
            workspace={workspace}
          />
          {withWorkspaceName && (
            <TextBase
              color="text-ds-natural-600"
              label={workspace.workspaceName}
              ellipsis
            />
          )}
        </div>
      )}
      {location.entity === 'folder' && (
        <>
          <div className="basis-1">
            <RightOutlineIcon
              size={16}
              color={ColorHex.natural300}
            />
          </div>
          <div className="flex items-center gap-1">
            <FolderIcon
              size={16}
              color={ColorHex.natural500}
            />
            <TextBase
              color="text-ds-natural-600"
              label={folder?.name}
              ellipsis
            />
          </div>
        </>
      )}
    </div>
  );
};
